import { useLocation, useNavigate } from 'react-router-dom';
import uuid from 'react-uuid';
import { t } from 'i18next';
import { Button } from '@peacecover/component';
import { ArrowLeft } from '@peacecover/icon';
import { useHandleHistoryBack } from '../../utils/useHandleHistoryBack';
import initializePortOne from '../../utils/PortOne';
import StickyHeader from '../components/bar/StickyHeader';
import { ROUTES } from '../../constants/routes';

const IdentityVerificationIntroPage = () => {
  const handleHistoryBack = useHandleHistoryBack();
  const navigate = useNavigate();
  const location = useLocation();
  const currentQueryParams = new URLSearchParams(location.search);
  const type = currentQueryParams.get('type');
  const isScene = type === 'scene';
  const handleRequestIdentityVerification = () => {
    const IMP = initializePortOne();
    const { origin, pathname, search } = window.location;
    const returnTo = currentQueryParams.get('return_to');
    const redirectPath = returnTo || pathname + search;
    const typeParam = type ? `&type=${type}` : '';

    IMP.certification({
      merchant_uid: `imp-${uuid()}`,
      min_age: 14,
      company: '포카판',
      popup: false,
      m_redirect_url: `${origin}/identity-verification/callback?redirect_path=${encodeURIComponent(
        redirectPath
      )}${typeParam}`
    });
  };

  const renderTitle = () => {
    switch (type) {
      case 'invite':
        return t('IdentityVerification.inviteTitle');
      case 'scene':
        return t('IdentityVerification.sceneTitle');
      default:
        return t('IdentityVerification.title');
    }
  };

  return (
    <div
      className={`min-h-screen pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] ${isScene ? 'bg-background-dark' : 'bg-background-light dark:bg-background-dark'}`}
    >
      <StickyHeader
        showBackButton={!isScene}
        onClickBackButton={handleHistoryBack}
        leftContent={<ArrowLeft className="text-main-dark-1" onClick={handleHistoryBack} />}
      />
      <div className="mt-[250px] flex flex-col items-center justify-center">
        <VerificationImage type={type ?? ''} />
        <h1
          className={`text-[26px] font-bold leading-[31px] whitespace-pre-line text-center ${isScene ? 'text-main-dark-1 mt-[34px]' : 'text-text-main-lv1 mt-[30px]'}`}
        >
          {renderTitle()}
        </h1>
        {isScene && (
          <p className="text-[15px] font-medium leading-[18px] text-main-dark-4 text-center mt-[14px]">
            {t('IdentityVerification.sceneDescription')}
          </p>
        )}
      </div>
      <div className="fixed bottom-0 left-0 right-0 px-[24px] pb-[calc(env(safe-area-inset-bottom)+10px)]">
        <Button
          size="large"
          className="w-full text-[17px] font-semibold leading-[20px]"
          onClick={handleRequestIdentityVerification}
        >
          {isScene ? t('IdentityVerification.verify') : t('next')}
        </Button>
        {isScene && (
          <Button
            size="large"
            btnColor="secondary"
            className="w-full text-[17px] font-semibold leading-[20px] mt-[10px] bg-secondary-dark"
            onClick={() => {
              if (currentQueryParams.get('return_to') && window.opener) {
                window.close();
              } else {
                navigate(ROUTES.SCENE.SETTING, { replace: true });
              }
            }}
          >
            {t('IdentityVerification.skip')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default IdentityVerificationIntroPage;

const VerificationImage = ({ type }: { type: string }) => {
  switch (type) {
    case 'scene':
      return (
        <img
          src="/assets/icons/shield_account.png"
          alt="shield_account"
          className="w-[88px] h-[88px]"
        />
      );
    default:
      return (
        <img
          src="/assets/icons/verfied.graphic.png"
          alt="verfied.graphic"
          className="w-[82px] h-[82px]"
        />
      );
  }
};
